import { get } from 'lodash';
import { invokeEvent } from 'shared-base';
import { Json } from '../types';

export const getGeneratorParams = (generator: Json) => {
  let json: Json = {};

  try {
    json = JSON.parse(generator.template);
  } catch (err) {
    invokeEvent('sentry', { err });
  }

  const output: any = {
    groups: {
      base: {
        id: 'base',
        title: 'Parts',
      },
    },
    parameters: {},
    values: {},
  };

  console.time('parse');

  // sliders
  get(json, 'Command.Controls', []).forEach((i: Json, index: number) => {
    const { Name, MinValue, MaxValue, IsInt, DefaultValue } = i;

    output.parameters[Name] = {
      id: Name,
      title: Name,
      type: 'slider',
      minValue: MinValue,
      maxValue: MaxValue,
      defaultValue: DefaultValue,
      order: index,
    };
  });

  // pickers
  get(json, 'Children[0].Children', [])
    .filter((i: Json) => i.Type === 'Switch')
    .forEach((i: Json, index: number) => {
      const { Id, Children } = i;

      output.parameters[Id] = {
        id: Id,
        title: Id,
        type: 'picker',
        options: Children.map((i: Json) => i.Id),
        order: index,
      };
    });

  // groups
  get(json, 'Command.Groups', []).forEach((i: Json) => {
    const { GroupControlName, Controls } = i;

    output.groups[GroupControlName] = {
      id: GroupControlName,
      title: GroupControlName,
      itemsCount: Controls.length,
    };

    Controls.forEach((i: string, index: number) => {
      output.parameters[i].groupId = GroupControlName;
      output.parameters[i].order = index;
    });
  });

  return output;
};

export const generatorParametersToValuesModel = (parameters: Json, extra = {}) => {
  const values: Json = {};

  Object.values(parameters).forEach((p) => {
    const { id, defaultValue } = p;
    values[id] = defaultValue;
  });

  return { ...values, ...extra };
};
